export default __webpack_public_path__ + "static/media/vulnerability-dataset.a353d5c8.png";